import React, { createContext, useContext, useMemo } from 'react';

const PreviewLanguageContext = createContext({
  language: 'english',
  direction: 'ltr',
});

/** Supplies language/direction for landing template previews in the builder */
export function PreviewLanguageProvider({ language = 'english', children }) {
  const value = useMemo(
    () => ({
      language,
      direction: language === 'hebrew' ? 'rtl' : 'ltr',
      isTransitioning: false,
      toggleLanguage: () => {},
      setLanguage: () => {},
      setDirection: () => {},
      t: {},
    }),
    [language]
  );

  return <PreviewLanguageContext.Provider value={value}>{children}</PreviewLanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(PreviewLanguageContext);
}
